export default __webpack_public_path__ + "static/media/chi2.af3b016f.jpg";